// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import MapController from "./map_controller"
application.register("map", MapController)
import PickController from "./pick_controller"
application.register("pick", PickController)
import ConsentController from "./consent_controller"
application.register("consent", ConsentController)
import SheetController from "./sheet_controller"
application.register("sheet", SheetController)
import SupportController from "./support_controller"
application.register("support", SupportController)
import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
import PresenceController from "./presence_controller"
application.register("presence", PresenceController)
import BannerController from "./banner_controller"
application.register("banner", BannerController)
import AdblockController from "./adblock_controller"
application.register("adblock", AdblockController)
import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)
import RevealController from "./reveal_controller"
application.register("reveal", RevealController)
